export const ALERT_TYPES = [
  {
    key: 'dividend_upcoming',
    label: 'Dividend Upcoming',
    icon: 'Calendar',
    color: '#16A34A',
    bgColor: 'rgba(22,163,74,0.12)',
    description: 'Notify before dividend payment date',
    conditionLabel: 'Days before payment',
    conditionUnit: 'days',
    defaultValue: 7,
    // Preset dropdown options for 'days' type — no free-text needed
    conditionPresets: [3, 5, 7, 14, 30],
    // Smart frequency: fires once when the stock enters the window,
    // then resets automatically after the dividend pays (next cycle re-triggers it)
    smartFrequency: 'daily',
    smartFrequencyNote: 'Reminds you once per day while inside the alert window — stops automatically after the dividend date passes.',
    // Whether frequency can be changed by user
    frequencyLocked: false,
  },
  {
    key: 'ex_date_upcoming',
    label: 'Ex-Dividend Date',
    icon: 'CalendarCheck',
    color: '#0D9488',
    bgColor: 'rgba(13,148,136,0.12)',
    description: 'Alert before ex-dividend date',
    conditionLabel: 'Days before ex-date',
    conditionUnit: 'days',
    defaultValue: 3,
    conditionPresets: [1, 2, 3, 5, 7],
    smartFrequency: 'daily',
    smartFrequencyNote: 'Reminds you each day inside the window. Ex-date is critical — missing it means missing the dividend.',
    frequencyLocked: false,
  },
  {
    key: 'price_drop',
    label: 'Price Drop Alert',
    icon: 'TrendingDown',
    color: '#DC2626',
    bgColor: 'rgba(220,38,38,0.12)',
    description: 'Alert when price drops significantly',
    conditionLabel: 'Drop % threshold',
    conditionUnit: 'percent',
    defaultValue: 5,
    conditionPresets: null, // free-text input
    smartFrequency: 'daily',
    smartFrequencyNote: 'At most one alert per day, even if the price drops multiple times.',
    frequencyLocked: false,
  },
  {
    key: 'price_rise',
    label: 'Price Rise Alert',
    icon: 'TrendingUp',
    color: '#16A34A',
    bgColor: 'rgba(22,163,74,0.12)',
    description: 'Alert when price rises significantly',
    conditionLabel: 'Rise % threshold',
    conditionUnit: 'percent',
    defaultValue: 10,
    conditionPresets: null,
    smartFrequency: 'daily',
    smartFrequencyNote: 'At most one alert per day, even if the price rises multiple times.',
    frequencyLocked: false,
  },
  {
    key: 'earnings_surprise',
    label: 'Earnings Surprise',
    icon: 'BarChart2',
    color: '#D97706',
    bgColor: 'rgba(217,119,6,0.12)',
    description: 'Alert on significant earnings beats/misses',
    conditionLabel: 'Surprise % threshold',
    conditionUnit: 'percent',
    defaultValue: 10,
    conditionPresets: null,
    smartFrequency: 'once',
    smartFrequencyNote: 'Earnings are a one-time event — fires once per earnings release then stops.',
    frequencyLocked: true, // no point giving other options
  },
  {
    key: 'sector_change',
    label: 'Sector Change',
    icon: 'Layers',
    color: '#3B82F6',
    bgColor: 'rgba(59,130,246,0.12)',
    description: 'Alert when sector classification changes',
    conditionLabel: null, // no threshold — any change triggers it
    conditionUnit: 'value',
    defaultValue: 1,
    conditionPresets: null,
    smartFrequency: 'once',
    smartFrequencyNote: 'Sector reclassification is a rare, one-time event.',
    frequencyLocked: true,
  },
  {
    key: 'dividend_cut',
    label: 'Dividend Cut',
    icon: 'Scissors',
    color: '#DC2626',
    bgColor: 'rgba(220,38,38,0.12)',
    description: 'Alert when dividend is reduced',
    conditionLabel: null,
    conditionUnit: 'value',
    defaultValue: 1,
    conditionPresets: null,
    smartFrequency: 'once',
    smartFrequencyNote: 'Fires once when a cut is first detected — you only need to know once.',
    frequencyLocked: true,
  },
  {
    key: 'dividend_increase',
    label: 'Dividend Increase',
    icon: 'ArrowUpCircle',
    color: '#16A34A',
    bgColor: 'rgba(22,163,74,0.12)',
    description: 'Alert when dividend is raised',
    conditionLabel: null,
    conditionUnit: 'value',
    defaultValue: 1,
    conditionPresets: null,
    smartFrequency: 'once',
    smartFrequencyNote: 'Fires once when an increase is first detected.',
    frequencyLocked: true,
  },
  {
    key: 'options_expiry',
    label: 'Options Expiry',
    icon: 'Clock',
    color: '#D97706',
    bgColor: 'rgba(217,119,6,0.12)',
    description: 'Alert before options positions expire',
    conditionLabel: 'Days before expiry',
    conditionUnit: 'days',
    defaultValue: 7,
    conditionPresets: [1, 3, 5, 7, 14],
    smartFrequency: 'daily',
    smartFrequencyNote: 'Daily reminders are useful for options — each day closer to expiry matters for your decision.',
    frequencyLocked: false,
  },
  {
    key: 'income_milestone',
    label: 'Income Milestone',
    icon: 'Trophy',
    color: '#CA8A04',
    bgColor: 'rgba(202,138,4,0.12)',
    description: 'Alert when annual income hits a milestone',
    conditionLabel: 'Milestone amount ($)',
    conditionUnit: 'dollars',
    defaultValue: 25000,
    conditionPresets: [5000, 10000, 25000, 50000, 100000],
    smartFrequency: 'once',
    smartFrequencyNote: 'Fires once when your portfolio crosses the milestone — no need to repeat.',
    frequencyLocked: true,
  },
  {
    key: 'options_profit_target',
    label: 'Options Profit Target',
    icon: 'Target',
    color: '#7C3AED',
    bgColor: 'rgba(124,58,237,0.12)',
    description: 'Alert when an open option reaches your profit % target',
    conditionLabel: 'Profit % target',
    conditionUnit: 'percent',
    defaultValue: 50,
    conditionPresets: [25, 50, 75, 90],
    conditionAllowCustom: true,
    smartFrequency: 'daily',
    smartFrequencyNote: 'Checks daily — fires when any open option hits your profit target. Consider closing to lock in gains.',
    frequencyLocked: false,
  },
  {
    key: 'options_stop_loss',
    label: 'Options Stop Loss',
    icon: 'ShieldAlert',
    color: '#DC2626',
    bgColor: 'rgba(220,38,38,0.12)',
    description: 'Alert when an open option loss exceeds your threshold',
    conditionLabel: 'Max loss % of premium',
    conditionUnit: 'percent',
    defaultValue: 100,
    conditionPresets: [50, 100, 150, 200],
    conditionAllowCustom: true,
    smartFrequency: 'daily',
    smartFrequencyNote: 'Checks daily — fires when your loss on an open option exceeds the set % of the premium collected.',
    frequencyLocked: false,
  },
  {
    key: 'put_assignment_risk',
    label: 'Put Assignment Risk',
    icon: 'AlertTriangle',
    color: '#EA580C',
    bgColor: 'rgba(234,88,12,0.12)',
    description: 'Alert when your sold put nears or crosses the strike',
    conditionLabel: 'Warning zone (% above strike)',
    conditionUnit: 'percent',
    defaultValue: 10,
    conditionPresets: [5, 10, 15, 20],
    conditionAllowCustom: true,
    smartFrequency: 'daily',
    smartFrequencyNote: 'Checks daily — fires at your warning zone (amber), in-the-money (orange), and critical ITM < 14d (red).',
    frequencyLocked: false,
    adminOnly: true,
  },
];

export const NOTIFICATION_TYPE_CONFIG = {
  dividend_upcoming:  { icon: 'Calendar',       color: '#16A34A', label: 'Dividend Upcoming' },
  ex_date_upcoming:   { icon: 'CalendarCheck',  color: '#0D9488', label: 'Ex-Date Alert' },
  price_drop:         { icon: 'TrendingDown',   color: '#DC2626', label: 'Price Drop' },
  price_rise:         { icon: 'TrendingUp',     color: '#16A34A', label: 'Price Rise' },
  earnings_surprise:  { icon: 'Zap',            color: '#D97706', label: 'Earnings Surprise' },
  sector_change:      { icon: 'RefreshCw',      color: '#3B82F6', label: 'Sector Change' },
  dividend_cut:       { icon: 'Scissors',       color: '#DC2626', label: 'Dividend Cut' },
  dividend_increase:  { icon: 'ArrowUpCircle',  color: '#16A34A', label: 'Dividend Increase' },
  options_expiry:        { icon: 'Clock',       color: '#D97706', label: 'Options Expiry' },
  income_milestone:      { icon: 'Trophy',      color: '#CA8A04', label: 'Income Milestone' },
  options_profit_target: { icon: 'Target',        color: '#7C3AED', label: 'Options Profit Target' },
  options_stop_loss:     { icon: 'ShieldAlert',   color: '#DC2626', label: 'Options Stop Loss' },
  put_assignment_risk:   { icon: 'AlertTriangle', color: '#EA580C', label: 'Put Assignment Risk' },
  system:                { icon: 'Info',          color: '#64748B', label: 'System' },
};

export const getAlertTypeConfig = (key) =>
  ALERT_TYPES?.find((t) => t?.key === key) || ALERT_TYPES?.[0];

export const getConditionText = (alert) => {
  const cfg = getAlertTypeConfig(alert?.alert_type);
  const val = alert?.condition_value;
  switch (alert?.alert_type) {
    case 'price_drop':        return `Price drops > ${val}%`;
    case 'price_rise':        return `Price rises > ${val}%`;
    case 'earnings_surprise': return `EPS surprise > ${val}%`;
    case 'dividend_upcoming': return `Within ${val} days of payment`;
    case 'ex_date_upcoming':  return `Within ${val} days of ex-date`;
    case 'options_expiry':        return `Expiring within ${val} days`;
    case 'income_milestone':      return `Annual income ≥ $${Number(val)?.toLocaleString()}`;
    case 'dividend_cut':          return 'Any dividend cut detected';
    case 'dividend_increase':     return 'Any dividend increase detected';
    case 'sector_change':         return 'Any sector reclassification';
    case 'options_profit_target':  return `Option profit ≥ ${val}%`;
    case 'options_stop_loss':      return `Option loss ≥ ${val}% of premium`;
    case 'put_assignment_risk':    return `Warn when stock within ${val}% of strike`;
    default:                       return `${cfg?.conditionLabel}: ${val}`;
  }
};
